import * as config from "config";
import { call, put, select, takeLatest } from "redux-saga/effects";
import * as types from "store/actions/input/claims/claimsActionTypes";
import * as claimsSelectors from "store/selectors/input/claims/claimsSelectors";
import * as utils from "utils";

export function* retrieveClaimsColumnMapping() {
  const mappingData = yield select(
    claimsSelectors.selectClaimsFileColumnMappingDisplay
  );
  try {
    const response = yield call(
      utils.authenticatedFetch,
      config.endpoints.claims(`excel/column-mappings/${mappingData.claimsKey}`)
    );
    const meta_data = yield call([response, response.json]);
    yield put({
      type: types.CLAIMS_FILE_COLUMN_MAPPING_DISPLAY_LOADED,
      payload: meta_data,
    });
  } catch (e) {
    yield put({
      type: types.CLAIMS_FILE_COLUMN_MAPPING_DISPLAY_LOAD_FAILED,
      payload: e,
    });
  }
}

export default function* claimsSaga() {
  yield takeLatest(
    types.START_CLAIMS_FILE_COLUMN_MAPPING_DISPLAY_LOAD,
    retrieveClaimsColumnMapping
  );
}
